import { OneDataCollection, useDataCollectionSource } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { useOpenDashboardAction } from 'modules/ai/copilotActions/canvas/dashboards/useOpenDashboardAction'

type DiscoverCard = {
  id: string
  title: string
  description: string
  prompt: string
  emoji: string
}

const DiscoverCards = () => {
  const { sendPromptForNewDashboard } = useOpenDashboardAction()

  const DISCOVER_CARDS: DiscoverCard[] = [
    {
      id: 'card-1',
      title: i18n.t('ai_reports.discover.cards.card_1.title'),
      description: i18n.t('ai_reports.discover.cards.card_1.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_1.prompt'),
      emoji: '💰',
    },
    {
      id: 'card-2',
      title: i18n.t('ai_reports.discover.cards.card_2.title'),
      description: i18n.t('ai_reports.discover.cards.card_2.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_2.prompt'),
      emoji: '📈',
    },
    {
      id: 'card-3',
      title: i18n.t('ai_reports.discover.cards.card_3.title'),
      description: i18n.t('ai_reports.discover.cards.card_3.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_3.prompt'),
      emoji: '🧾',
    },
    {
      id: 'card-4',
      title: i18n.t('ai_reports.discover.cards.card_4.title'),
      description: i18n.t('ai_reports.discover.cards.card_4.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_4.prompt'),
      emoji: '⏰',
    },
    {
      id: 'card-5',
      title: i18n.t('ai_reports.discover.cards.card_5.title'),
      description: i18n.t('ai_reports.discover.cards.card_5.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_5.prompt'),
      emoji: '🏖️',
    },
    {
      id: 'card-6',
      title: i18n.t('ai_reports.discover.cards.card_6.title'),
      description: i18n.t('ai_reports.discover.cards.card_6.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_6.prompt'),
      emoji: '📅',
    },
    {
      id: 'card-7',
      title: i18n.t('ai_reports.discover.cards.card_7.title'),
      description: i18n.t('ai_reports.discover.cards.card_7.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_7.prompt'),
      emoji: '👥',
    },
    {
      id: 'card-8',
      title: i18n.t('ai_reports.discover.cards.card_8.title'),
      description: i18n.t('ai_reports.discover.cards.card_8.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_8.prompt'),
      emoji: '📝',
    },
    {
      id: 'card-9',
      title: i18n.t('ai_reports.discover.cards.card_9.title'),
      description: i18n.t('ai_reports.discover.cards.card_9.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_9.prompt'),
      emoji: '⚠️',
    },
  ]

  const source = useDataCollectionSource<DiscoverCard>({
    dataAdapter: {
      fetchData: () => ({ records: DISCOVER_CARDS }),
    },
    itemOnClick: (item: DiscoverCard) => () => {
      sendPromptForNewDashboard(item.prompt)
    },
  })

  return (
    <OneDataCollection
      source={source}
      visualizations={[
        {
          type: 'card',
          options: {
            title: (item: DiscoverCard) => item.title,
            description: (item: DiscoverCard) => item.description,
            avatar: (item: DiscoverCard) => ({ type: 'emoji', emoji: item.emoji }),
            cardProperties: [],
          },
        },
      ]}
    />
  )
}

export default DiscoverCards
